<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">
                    <div>门店编辑</div>
                </div>

                <div class="admin_main_block_right">
                    <div><el-button icon="el-icon-back" @click="$router.go(-1)">返回</el-button></div>
                </div>
            </div>

            <div class="admin_form_main">
                <el-form  label-width="100px" ref="info" :model="info">
                      <el-form-item label="TOPIC" prop="topic" :rules="[{required:true,message:'TOPIC不能为空',trigger: 'blur' }]"><el-input placeholder="请输入TOPIC" v-model="info.topic" style="width:360px;"></el-input></el-form-item>
                    <el-form-item label="灯名" prop="dengm" :rules="[{required:true,message:'灯名不能为空',trigger: 'blur' }]"><el-input placeholder="请输入灯名" v-model="info.dengm" style="width:360px;"></el-input></el-form-item>
                    <el-form-item label="IMEI" prop="imei" :rules="[{required:true,message:'IMEI不能为空',trigger: 'blur' }]"><el-input placeholder="请输入IMEI" v-model="info.imei" style="width:360px;"></el-input></el-form-item>
                    <el-form-item label="ICCID"  prop="iccid" :rules="[{required:true,message:'ICCID不能为空',trigger: 'blur' }]"><el-input placeholder="请输入ICCID"  v-model="info.iccid" style="width:560px;"></el-input></el-form-item>
                  <el-form-item label="IMSI"  prop="imsi" :rules="[{required:true,message:'IMSI不能为空',trigger: 'blur' }]"><el-input placeholder="请输入IMSI"  v-model="info.imsi" style="width:560px;"></el-input></el-form-item>



                    <el-form-item>
                        <el-button type="primary" @click="submitForm('info')">提交</el-button>
                        <el-button @click="resetForm('info')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
      return {
          edit_id:0,
          info:{
              F_VR_MINGC:'',
              F_VR_ZHAOP:'',
              F_VR_DIZ:'',
          },
          list:[],
          upload_headers:{},
      };
    },
    watch: {},
    computed: {},
    methods: {
        resetForm:function(e){
            this.$refs[e].resetFields();
        },
        submitForm:function(e){
            let _this = this;

            // 验证表单
            this.$refs[e].validate(function(res){
                if(res){
                    //  判断是Add 或者 Edit
                    let url = _this.$api.addMend;
                    if(_this.edit_id>0){
                        url = _this.$api.editMend+_this.edit_id;
                    }
                    // Http 请求
                    _this.$post(url,_this.info).then(function(res){
                        if(res.code == 200){
                            _this.$message.success("编辑成功");
                            _this.$router.go(-1);
                        }else{
                            _this.$message.error("编辑失败");
                        }
                    });
                }
            });
        },
        get_goods_class_info:function(){
            let _this = this;
            this.$get(this.$api.editMend+this.edit_id).then(function(res){
                _this.info = res.data.list;
                _this.list = res.data.info;
            })

        },
        get_goods_class_list:function(){
            let _this = this;
            this.$get(this.$api.addMend).then(function(res){
                _this.list = res.data;
            })
        },
        selectChange:function(){
            this.$forceUpdate();
        },
        handleAvatarSuccess(res) {
            this.info.F_VR_ZHAOP = res.data;
            this.$forceUpdate();
        },
    },
    created() {
        this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到

        // 判断是否是编辑
        this.info.pid = 0;
        if(!this.$isEmpty(this.$route.params.id)){
            this.edit_id = this.$route.params.id;
        }else{
            return this.get_goods_class_list();
        }

        if(this.edit_id>0){
            this.get_goods_class_info();
        }else{
            this.get_goods_class_list();
        }




    },
    mounted() {}
};
</script>
<style lang="scss" scoped>

</style>
